/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import { sanitize as sanitizeHtml } from 'isomorphic-dompurify';

const allowedTags = [
  'div',
  'figure',
  'li',
  'ol',
  'p',
  'ul',
  'abbr',
  'em',
  'br',
  'span',
  'strong',
  'u',
  'img',
  'sub',
  'sup'
];

const allowedAttributes = {
  img: ['alt', 'height', 'width', 'style', 'data-latex', 'data-text', 'src'],
  span: []
};

const allowedSchemes = ['data', 'http', 'https'];

// Use sanitize = true in case you know the data to insert as HTML is not supposed to be executable HTML. For example: JSON LD Data for Rich Text Snippets on Search Engines.
const Dangerous = ({
  html = '',
  as: As = 'script',
  id,
  className,
  sanitize = true,
  type,
  ...rest
}) => {
  let sanitizedHTML = html;

  if (sanitize)
    sanitizedHTML = sanitizeHtml(html, {
      allowedTags,
      allowedAttributes,
      allowedSchemes
    });

  return (
    <As
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
      className={className}
      type={type}
      id={id}
      {...rest}
    />
  );
};

Dangerous.defaultProps = {
  html: '',
  id: '',
  as: 'script',
  className: '',
  sanitize: true,
  type: undefined
};

Dangerous.propTypes = {
  html: PropTypes.string,
  id: PropTypes.string,
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  className: PropTypes.string,
  sanitize: PropTypes.bool,
  type: PropTypes.string
};

export default Dangerous;
